import * as React from 'react';

import { useLocation, useParams } from 'js/lib/useRouter';

import ProductDescriptionPageHeader from 'bundles/composable-page-header-consumer/header-renderers/ProductDescriptionPageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import PaidMediaFooter from 'bundles/page-footer/components/PaidMediaFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import { useSpecializationPageData } from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import { getPageHeaderProps } from 'bundles/unified-description-page-common/utils/getProductHeaderProps';
import isComposablePageHeaderEnabledOnXDP from 'bundles/unified-description-page-common/utils/isComposablePageHeaderEnabledOnXDP';
import isGoogleMarketingPage from 'bundles/unified-description-page-common/utils/isGoogleMarketingPage';
import { isPaidMediaXDP } from 'bundles/unified-description-page-common/utils/isPaidMediaXDP';

const ConsumerHeaderFooterWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const params = useParams();
  const s12nPageData = useSpecializationPageData();
  const shouldShowComposablePageHeader = isComposablePageHeaderEnabledOnXDP();
  let productSlug: string | undefined = params.productSlug;

  // Ensure we use the canonical slug if on Google XDP.
  if (isGoogleMarketingPage(location.pathname)) {
    productSlug = s12nPageData?.slug;
  }

  return (
    <React.Fragment>
      {shouldShowComposablePageHeader ? (
        <React.Fragment>
          <ProductDescriptionPageHeader />
          <UniversalPageFeatures />
        </React.Fragment>
      ) : (
        <PageHeader {...getPageHeaderProps(location.pathname, productSlug)} />
      )}
      <main>{children}</main>
      {isPaidMediaXDP(location.pathname) ? <PaidMediaFooter isStickyBarPresent /> : <PageFooter isStickyBarPresent />}
    </React.Fragment>
  );
};

export default ConsumerHeaderFooterWrapper;
